import _ from "lodash";
import { createSlice } from "@reduxjs/toolkit";

export interface ListScreenSettingsState  {
  showMemo: boolean,
}

const initialState:ListScreenSettingsState = {
  showMemo: false,
};

/**
 * Slice for controlling List Screen Settings
 */
const listScreenSettingsSlice = createSlice({
  name: 'listScreenSettingsSlice',
  initialState,
  reducers: {
    toggleMemo: (state) => {
      state.showMemo = !state.showMemo;
    },
    resetListScreenSettings: () => _.cloneDeep(initialState),
  }
});

export default listScreenSettingsSlice.reducer;

export const {
  toggleMemo,
  resetListScreenSettings,
} = listScreenSettingsSlice.actions;
